import { QueryFactory } from "../../../../Common";
export const QGetEventsCountByTag = QueryFactory("GetEventsCountByTag");
//# sourceMappingURL=GetEventsCountByTag.js.map